import {
    BaseTransitionModel,
} from '@src/slide/domain/ui-model/element-modeles/transition/transition-model/base-transition-model';
import { IAnimationSetting, IFlashTransition } from '@src/slide/domain/ui-model/element-modeles/transition/interface';
import { TransitionConfig } from '@src/slide/domain/ui-model/element-modeles/transition/config';
import {
    AnimationLabel,
    ImplementationType,
    TransitionTarget, TransitionType,
} from '@src/slide/domain/ui-model/element-modeles/transition/constants';

export class FlashTransitionModel extends BaseTransitionModel<IFlashTransition> implements IFlashTransition {
    public type = TransitionType.FLASH;

    public getAnimationSetting(): IAnimationSetting[] {
        return [{
            fromStyle: TransitionConfig.PROGRESS_START,
            toStyle: {
                ...TransitionConfig.PROGRESS_END,
                duration: this.animationDuration / 2,
            },
            target: TransitionTarget.EXIT,
        }, {
            fromStyle: TransitionConfig.PROGRESS_END,
            toStyle: {
                ...TransitionConfig.PROGRESS_START,
                duration: this.animationDuration / 2,
            },
            target: TransitionTarget.ENTER,
            label: AnimationLabel.NEXT,
        }];
    }

    public getImplementationType(): ImplementationType {
        return ImplementationType.CUSTOM;
    }
}
